import React from 'react';
export default function PageNotFound() {
    return (
        <div>
            <span>no found</span>
        </div>
    )
}